/**
 * Tokyo Reads — search UX, kaart #63 punten 1 en 2 (theme-zijsessie 4, 2026-09-25).
 * Own asset, no theme.js changes. Loaded from snippets/head.liquid (defer).
 *
 * 1. Search results page: a clear button (x) inside the page's search field (the in-page
 *    <search-popdown> under [data-main-input-search]). Shown while the field holds text;
 *    tap = empty the field, keep the keyboard/focus in it, let predictive search update.
 *    Separate from the popdown's own close button (Jan: "los van het sluitkruis").
 *    Icon = the theme's own close icon (cloned from that hidden close button), 44 px tap zone.
 * 2. Re-opening the search popdown with a term already in it: the theme's focus trap puts the
 *    caret BEFORE the term on Android, so backspace does nothing. When a search popdown opens,
 *    the first focus on its search input within 1.5 s moves the caret to the end.
 */
(function () {
  'use strict';

  var isNl = false;
  try {
    var loc = (window.Shopify && window.Shopify.locale) || document.documentElement.lang || '';
    isNl = String(loc).toLowerCase().indexOf('nl') === 0;
  } catch (e) {
    isNl = false;
  }

  // ---- 1. clear button on the results page ------------------------------------------------------
  function addClearButton() {
    var holder = document.querySelector('[data-main-input-search] .search-form__input-holder');
    if (!holder || holder.querySelector('.tr-search-clear')) {
      return;
    }
    var input = holder.querySelector('input[type="search"]');
    if (!input) {
      return;
    }
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'tr-search-clear';
    btn.setAttribute('aria-label', isNl ? 'Zoekopdracht wissen' : 'Clear search');
    var icon = holder.querySelector('.search-popdown__close svg');
    if (icon) {
      btn.appendChild(icon.cloneNode(true));
    } else {
      btn.textContent = '×';
    }
    holder.appendChild(btn);

    var style = document.createElement('style');
    style.textContent =
      '.tr-search-clear{position:absolute;top:50%;right:0;transform:translateY(-50%);width:44px;height:44px;' +
      'display:flex;align-items:center;justify-content:center;padding:0;margin:0;border:0;background:none;' +
      'color:inherit;cursor:pointer;-webkit-tap-highlight-color:transparent}' +
      '.tr-search-clear[hidden]{display:none}' +
      '.tr-search-clear svg{width:14px;height:14px;display:block}' +
      '[data-main-input-search] .search-form__input{padding-right:44px}' +
      '[data-main-input-search] .search-form__input::-webkit-search-cancel-button{-webkit-appearance:none;display:none}';
    document.head.appendChild(style);

    function sync() {
      btn.hidden = !input.value;
    }
    input.addEventListener('input', sync);
    sync();
    btn.addEventListener('mousedown', function (e) {
      e.preventDefault(); // keep focus (and the mobile keyboard) on the input
    });
    btn.addEventListener('click', function () {
      input.value = '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
      sync();
      try {
        input.focus({ preventScroll: true });
      } catch (err) {
        input.focus();
      }
    });
  }

  // ---- 2. caret after the term when the field gets focus programmatically --------------------------
  // The popdown focuses its input itself (open + focus trap); that focus must put the caret after the
  // term. A focus caused by the visitor tapping INTO the field keeps the tapped position. setTimeout,
  // not requestAnimationFrame: rAF is paused in background tabs/panes (runbook par 5).
  var lastTapOnInput = 0;
  function isSearchInput(el) {
    return !!(el && el.tagName === 'INPUT' && el.type === 'search' && el.closest && el.closest('search-popdown'));
  }
  document.addEventListener('pointerdown', function (e) {
    if (isSearchInput(e.target)) {
      lastTapOnInput = Date.now();
    }
  }, true);
  document.addEventListener('focusin', function (e) {
    var inp = e.target;
    if (!isSearchInput(inp) || Date.now() - lastTapOnInput < 500) {
      return;
    }
    function toEnd() {
      var n = inp.value.length;
      if (!n || document.activeElement !== inp) {
        return;
      }
      if (inp.selectionStart === 0 && inp.selectionEnd === 0) {
        try {
          inp.setSelectionRange(n, n);
        } catch (err) { /* some input types refuse selection: nothing to fix then */ }
      }
    }
    setTimeout(toEnd, 0);
    setTimeout(toEnd, 80); // the theme's focus trap may focus once more after its transition
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addClearButton);
  } else {
    addClearButton();
  }
})();
